<!-- /上传  -->
<template>
	<div>
		<el-upload :accept="uploadFormat" list-type="picture-card" :on-preview="handlePictureCardPreview" action=""
			:drag="false" :limit="num" :multiple="false" :file-list="imgUrls" :http-request="uploadHttp"
			:before-upload="beforeAvatarUpload" :on-remove="handleRemove" :on-change="onChange">
			<!-- <i class="el-icon-plus avatar-uploader-icon"></i> -->
			<i class="el-icon-plus"></i>
			<div class="el-upload__tip" slot="tip">不超过1MB</div>
		</el-upload>
		<el-dialog :visible.sync="dialogVisible">
			<img width="100%" :src="dialogImageUrl" alt="" />
		</el-dialog>
		<!-- <div style="margin-top:100px">
    <img :src="imgUrl" alt="测试图片">
    </div> -->
	</div>
</template>

<script>
	// import ossClient from "../../assets/js/aliyun.oss.client";
	import OSS from "ali-oss";
	import {
		GetUploadKey
	} from "../../assets/js/network/network";
  import BMF from 'browser-md5-file';
	export default {
		name: "upload",
		props: {
			imgUrlArray: Array,
			num: Number,
		},
		data() {
			return {
        fileNameMd5:'',
				fileMd5: '',
				uploadFormat: ".jpg,.png,.jpeg",
				dialogImageUrl: "",
				dialogVisible: false,
				imgUrls: [],
				uploadConf: {
					region: "oss-cn-qingdao",
					accessKeyId: "LTAI4FsijXNvoujPd792kGup",
					accessKeySecret: "suU9QjXSQOeT9ZUWBmhb1IByjuCGuC",
					bucket: "sourcelib",
					file_power: "public-read",
					upload_dir: "",
					// stsToken: null,
				},
			};
		},
		watch: {
			imgUrlArray(val) {
				console.log(this.imgUrlArray);
				this.getData();
			},
		},
		mounted() {
			this.init();
			console.log(this.imgUrlArray, this.num);
			if (!!this.imgUrlArray) {
				this.getData();
			}
			// this.getData();
		},
		methods: {
			getData() {
				this.imgUrls = [];
				if (!!this.imgUrlArray) {
					this.imgUrlArray.map((item) => {
						this.imgUrls.push({
							url: item,
						});
					});
				} else {
					this.imgUrls = [];
				}
			},
			handlePictureCardPreview(file) {
				console.log(file);
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			/**
			 * 初始化
			 */
			init() {
				//获取阿里云token  这里是后台返回来的数据
				let data = {
					upload_type: "",
				};
				GetUploadKey(data).then((res) => {
					console.log(res);
					this.uploadConf.region = res.ret.region;
					this.uploadConf.accessKeyId = 'LTAI4FsijXNvoujPd792kGup';
					this.uploadConf.accessKeySecret = 'suU9QjXSQOeT9ZUWBmhb1IByjuCGuC';
					this.uploadConf.bucket = res.ret.bucket;
					this.uploadConf.file_power = res.ret.file_power;
					this.uploadConf.upload_dir = res.ret.upload_dir;

					// this.uploadConf.stsToken = res.ret.stsToken;
				});
			},

			/**
			 * 阿里云OSS上传
			 */
			uploadHttp({
				file
			}) {
				let _this = this;
        _this.fileMd5 = ''
        const bmf = new BMF();
        bmf.md5(
          file,
          (err, md5) => {
            if(err){
              this.$message.error("解析失败")
              return
            }
            if(md5){
              _this.fileMd5　= md5
              _this.fileNameMd5 = _this.fileMd5 + '.' + file.name.substring(file.name.lastIndexOf(".")+1);
            }
            if (_this.fileMd5 != '') {
              // _this.uploadHttp({file})
              const fileName = `${_this.uploadConf.upload_dir}/${_this.fileNameMd5}`; //定义唯一的文件名
              var ossClient = (conf) => {
                return new OSS(conf);
              };
              ossClient(_this.uploadConf)
                .put(fileName, file, {
                  headers: {
                    "x-oss-object-acl": "public-read",
                  },
                  //   ContentType: "image/jpeg",
                })
                .then(({
                  res,
                  url,
                  name
                }) => {
                  if (res && res.status == 200) {
                    // console.log(`阿里云OSS上传图片成功回调`, res, url, name);
                    console.log(file);
                    _this.imgUrls.push({
                      status: "success",
                      uid: file.uid,
                      url: url,
                    });
                    console.log(_this.imgUrls);
                    // consloe.log(fileList)
                    // console.log(_this.imgUrls,_this.imgUrl)
                    _this.$emit("imgUrlEmit", _this.imgUrls);
                  }
                })
                .catch((err) => {
                  console.log(`阿里云OSS上传图片失败回调`, err);
                });
            }
          },
        );




			},

			/**
			 * 上传之前
			 */
			beforeAvatarUpload(file) {
			  console.log()
				this.fileNameMd5 =
					this.$md5(file.name.split(".")[0] + Date.parse(new Date()) / 1000) +
					"." +
					file.name.split(".")[1];
				// console.log(this.fileNameMd5)
				//   const isJPEG = file.name.split(".")[1] === "jpeg";
				//   const isJPG = file.name.split(".")[1] === "jpg";
				//   const isPNG = file.name.split(".")[1] === "png";
				// const isLt500K = file.size / 1024 /1024 / 500 < 2;
				//   if (!isJPG && !isJPEG && !isPNG) {
				//     this.$message.error("上传图片只能是 JPEG/JPG/PNG 格式!");
				//   }
				// if (!isLt500K) {
				//   this.$message.error("单张图片大小不能超过 500KB!");
				// }
				// //   return (isJPEG || isJPG || isPNG) && isLt500K;
				// return isLt500K;
        const isLt1MB = file.size / 1024 / 1024 < 1;
        // console.log(333,isLt1MB)
        if (!isLt1MB) {
          this.$message.error("单张图片大小不能超过 1MB!");
        }
        return isLt1MB;
			},
			onChange(file, fileList) {
				console.log(111, file);
				console.log(fileList);
				// let  _this = this;
				// var fileReader = new FileReader();
				// var dataFile = file.raw
				// let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice
				// var spark = new SparkMD5
				// fileReader.readAsBinaryString(dataFile)
				//
				// fileReader.onload = function (e){
				//   spark.appendBinary(e.target.result)
				//   var md5 = spark.end()
				//   console.log(md5)
				// }


			},
			/**
			 * 移除图片
			 */
			handleRemove(file, fileList) {
				console.log(`移除图片回调`, fileList);
				this.imgUrls = fileList;
				this.$emit("imgUrlEmit", this.imgUrls);
			},
		},
	};
</script>

<style>
</style>
